/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.megadodo.MegadodoRefType
*/
export var MegadodoRefType;
(function (MegadodoRefType) {
    MegadodoRefType["PROJECT"] = "PROJECT";
    MegadodoRefType["SESSION"] = "SESSION";
    MegadodoRefType["PROCESS"] = "PROCESS";
    MegadodoRefType["USER"] = "USER";
    MegadodoRefType["TOOL"] = "TOOL";
    MegadodoRefType["SCHEDULER"] = "SCHEDULER";
    MegadodoRefType["HOOK"] = "HOOK";
    MegadodoRefType["EVENT"] = "EVENT";
    MegadodoRefType["DOCUMENT"] = "DOCUMENT";
    MegadodoRefType["KIT"] = "KIT";
})(MegadodoRefType || (MegadodoRefType = {}));
//# sourceMappingURL=MegadodoRefType.js.map